import { apiOrchestrator, apiStrapi } from 'services/apiService';

export const debugApiRequests = () => {
  console.log('=== DEBUG API REQUESTS ===');

  // Verificar headers das APIs
  const orchestratorHeaders = apiOrchestrator.getInstance().defaults.headers.common;
  const strapiHeaders = apiStrapi.getInstance().defaults.headers.common;

  console.log('Orchestrator Headers:', orchestratorHeaders);
  console.log('Strapi Headers:', strapiHeaders);

  // Verificar localStorage
  const localStorageData = {
    AUTH_TOKEN: localStorage.getItem('AUTH_TOKEN'),
    user_id: localStorage.getItem('user_id'),
    'x-organization-uuid': localStorage.getItem('x-organization-uuid'),
    'x-cognito-userpool': localStorage.getItem('x-cognito-userpool'),
  };

  console.log('LocalStorage Data:', localStorageData);

  // Verificar se as instâncias estão configuradas
  console.log('Orchestrator Base URL:', apiOrchestrator.getInstance().defaults.baseURL);
  console.log('Strapi Base URL:', apiStrapi.getInstance().defaults.baseURL);

  return {
    orchestratorHeaders,
    strapiHeaders,
    localStorageData,
  };
};

export const testApiConnection = async () => {
  try {
    console.log('=== TESTING API CONNECTION ===');

    // Testar se o token está configurado
    const token = localStorage.getItem('AUTH_TOKEN');
    if (!token) {
      console.error('No token found in localStorage');
      return false;
    }

    // Testar requisição simples
    const response = await apiOrchestrator.get('/auth/me/test');
    console.log('Test response:', response);
    return true;
  } catch (error) {
    console.error('API connection test failed:', error);
    return false;
  }
};
